export enum WebAppColors {
  Gray_1 = '#BDBDBD'
}
